export const IMG = {
  logo: "/mindful-assets/uploads/logo.png",
  hero: "/mindful-assets/uploads/upload-4.jpeg",
  mindsetWall: "/mindful-assets/uploads/upload-5.jpeg",
  agnieszka: "/mindful-assets/uploads/agnieszka.jpeg",
  nika: "/mindful-assets/uploads/nika.jpeg",
  coachesCandid: "/mindful-assets/uploads/upload-1.jpeg",
  reflection: "/mindful-assets/uploads/upload-2.jpeg",
  joy: "/mindful-assets/uploads/joy-gym.jpeg",
  brandTees: "/mindful-assets/uploads/upload-3.jpeg",
  realCommunity: "/mindful-assets/uploads/community-group.webp",
  practice: "/mindful-assets/uploads/practice-wide.jpeg",
  meditation: "/mindful-assets/uploads/meditation.jpeg",
};

export const NAV_ITEMS = [
  ["About", "about"],
  ["Coaching", "coaching"],
  ["Community", "community"],
  ["Events", "events"],
  ["Contact", "contact"],
];

export const CONTACT_EMAIL = "hello@mindfulathleteclub.com";
export const INSTAGRAM_HANDLE = "@mindfulathlete_club";
export const INSTAGRAM_URL = "https://www.instagram.com/mindfulathlete_club";
export const SITE_URL = "mindfulathleteclub.com";
export const BOOKING_URL = "https://calendly.com/agnieszka-niegowski";
export const EVENT_OPTIONS = ["Next Workshop", "Community Session", "Other"];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -68, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
